import React from 'react'
import { useGenericRequestHandler } from '../../handlers/useGenericRequestHandler'

export const useChargebeeCheckoutMutation = () => {
  return useGenericRequestHandler({
    route: 'v1/c/newCheckout',
    method: 'POST'
  })
}
